module.exports = __webpack_public_path__ + "static/kwik_tow-9e5060ce3f33254a1799adb428cd773e.jpg";